import * as React from "react";
import {Fragment} from "react";
import {Route} from "react-router-dom";
import {
	arrayToObject,
	changeStateRaw,
	forEachObj,
	formatPrice,
	isEmpty,
	mapArrayToObject,
	mapObject,
	mapObjectName,
	mapObjectToArray,
	objectCompare,
	objectMerge,
	relativePath,
	saveMessage
} from "../lib/tools";
import {Button, Image, LoadingSpinner, RelativeSwitch, SearchField, SortedTable} from "../components/common/common";
import {
	Checkbox,
	DropDown,
	FormGroup,
	FormInput,
	FormList,
	FormText,
	ImageSelect,
	ImageUpload,
	ValidateForm
} from "../components/common/formValidation";
import {reduxWrapper} from "../globalState";
import {getImage} from "../lib/api";


export const ProductTool = (props) => (
	<RelativeSwitch>
		<Route path="/new" render={() => <ProductEdit/>}/>
		<Route path="/:id" render={({match: {params: {id}}}) => <ProductEdit key={id} id={id}/>}/>
		<Route render={() => <ProductOverview/>}/>
	</RelativeSwitch>
);

//<editor-fold desc="Product Edit">
class ProductEditRender extends React.Component {
	constructor(props) {
		super(props);
		
		this.state = {
			disabled: false,
			product: {},
			images: {},
			productTypes: {},
			vendors: {},
			attributes: {},
			configurations: [],
			configOverrides: [],
			config: {
				attributes: [],
				options: {}
			},
			loading: 0
		};
		
		this.createProductType = name => {
			return new Promise((resolve, reject) => {
				this.props.addProductTypes({
					data: {name},
					success: data => resolve(data.id),
					error: error => reject(error)
				});
			});
		};
		
		this.loadAttributes = () => {
			this.props.apiCall("GET", `/configuration/attributes`, data => {
				this.setState({attributes: arrayToObject(data)});
			});
		};
		
		this.createAttribute = (name) => {
			return new Promise((resolve, reject) => {
				this.props.addAttributes({
					data: {name},
					success: data => {
						this.loadAttributes();
						resolve(data.id);
					}
				});
			});
		};
		
		this.createOption = (attributeId, name) => {
			return new Promise((resolve, reject) => {
				this.props.addOptions({
					data: {attributeId, name},
					success: data => {
						resolve(data.id);
						this.loadAttributes();
					}
				});
			});
		};
		
		this.onSubmit = product => {
			
			this.configs = [];
			if (this.state.config.attributes.length > 0)
				this.getConfigs(this.state.config.attributes);
			product.configurations = this.configs;
			
			if (this.props.id) {
				this.props.apiCall("PUT", `/admin/product/${this.props.id}`, data => {
					this.props.sendMessage(saveMessage());
				}, product);
			} else {
				this.props.apiCall("POST", `/admin/products`, data => {
					this.props.sendMessage(saveMessage());
					this.props.history.push(relativePath(`../${data.id}`));
				}, product);
			}
		};
		
		this.getConfigs = (attributes, path = {}, override = {}) => {
			
			if (attributes.length < 1) {
				const config = this.state.configurations.find(x => objectCompare(x.options, path)) || {};
				this.configs.push(objectMerge(config, override, {
					options: mapObjectToArray(path, (x, i) => ({
						attributeId: i,
						optionId: x
					}))
				}));
				return;
			}
			const newAttributes = [...attributes];
			const attribute = newAttributes.pop();
			
			override = objectMerge(this.state.configOverrides.find(x => objectCompare(x.options, {
				...path,
				[attribute]: 0
			})), override);
			
			const options = this.state.config.options[attribute] || [];
			options.forEach(x => this.getConfigs(newAttributes, {...path, [attribute]: x}, override));
		};
		
		this.startLoading = () => this.setState(prev => ({loading: prev.loading + 1}));
		this.stopLoading = () => this.setState(prev => ({loading: prev.loading - 1}));
	}
	
	componentWillMount() {
		if (this.props.id) {
			this.startLoading();
			this.props.apiCall("GET", `/admin/product/${this.props.id}`, data => {
				data.customOptions = mapObjectToArray(data.customOptions, x => x.id);
				data.sections = data.sections.map(x => parseInt(x, 10));
				this.stopLoading();
				this.setState({
					product: data,
					configurations: data.configurations.map(x => Object.assign({}, x, {
						options: mapArrayToObject(x.options, y => ({key: y.attributeId, data: y.optionId}))
					})),
					config: {attributes: data.configAttributes || [], options: data.configOptions || {}}
				})
			});
		}
		
		this.loadAttributes();
	}
	
	render() {
		const {product = {}, configurations, attributes, config, loading} = this.state;
		const {productTypes, sections, options, customOptions, vendors} = this.props;
		const images = product.images || [];
		
		if (loading)
			return <LoadingSpinner/>;
		
		let subsections = {};
		forEachObj(sections, x => x.children.forEach(y => subsections[y.id] = y.title));
		
		return (
			<div className="productForm">
				<h1>Rediger Produkt</h1>
				<ValidateForm values={product} onChange={val => this.setState({product: val})} onSubmit={this.onSubmit}>
					
					<h3>Base info</h3>
					<Checkbox name="disabled" title="disabled"/>
					<FormInput name="name" req/>
					<FormInput name="price" type="number" req/>
					<FormInput name="qty" type="number" req/>
					<DropDown name="sections" options={subsections} multiple externalLabel/>
					<DropDown name="productType" options={productTypes} onCreate={this.createProductType} externalLabel/>
					<DropDown name="vendor" options={mapObjectName(vendors)} externalLabel/>
					<DropDown name="customOptions" options={mapObject(customOptions, x => x.name + " - " + x.type)} multiple externalLabel/>
					<FormInput name="url" type="url" req/>
					
					<h3>Description</h3>
					<FormText name="description"/>
					
					<h3>Bonus Info</h3>
					<FormGroup name="info">
						<FormInput name="minQty" type="number" title="Min Qty" req/>
						<Checkbox name="rent" title="Rentable"/>
					</FormGroup>
					
					<h3>Images</h3>
					<FormList name="images">
						{({value, index, onChange}) => <ImageUpload value={value} onChange={onChange}/>}
					</FormList>
					
					<h3>Thumbnail</h3>
					<ImageSelect name="thumbnail" images={images}/>
					
					<Button className="floatingBtn" submit>Save</Button>
				</ValidateForm>
				{this.props.id &&
					<Fragment>
						<h3>Config Options</h3>
						<ConfigBuilder value={config} onChange={val => this.setState({config: val})} lookup={{attributes: this.props.attributes, sections, options}}
						               images={images} attributes={attributes} overrides={this.state.configOverrides}
						               configurations={configurations} addImage={this.addImage} removeImage={this.removeImage}
						               onOverrideChange={val => this.setState({configOverrides: val})}
						               onConfigChange={val => this.setState({configurations: val})}
						               onCreateAttribute={this.createAttribute} onCreateOption={this.createOption}/>
					</Fragment>}
			</div>
		);
	}
}

const ProductEdit = reduxWrapper("loadCustomOptions", "getApiCall", "loadAttributes", "loadSections", "loadProductTypes", "loadOptions", "addAttributes", "addProductTypes", "addOptions", "loadVendors", "getSendMessage")(ProductEditRender);


const {Provider: ConfigProvider, Consumer: ConfigConsumer} = React.createContext({});

class ConfigBuilder extends React.Component {
	
	constructor(props) {
		super(props);
		
		this.state = {
			overrides: []
		};
		
		
		this.onOptionsChange = (id, val) => {
			this.props.onChange && this.props.onChange(changeStateRaw(this.props.value, ["options", id], val, false));
		};
		
		this.onAttributeChange = val => {
			this.props.onChange && this.props.onChange(Object.assign({}, this.props.value, {attributes: val}))
		};
		
		this.onConfigChange = (path, val) => {
			if (!this.props.onConfigChange) return;
			let values = this.props.configurations || [];
			const newVal = Object.assign({}, val, {options: path});
			const index = values.findIndex(x => objectCompare(path, x.options));
			if (~index)
				values[index] = newVal;
			else
				values.push(newVal);
			this.props.onConfigChange(values);
		};
		
		this.onConfigParentChange = (path, val) => {
			if (!this.props.onOverrideChange) return;
			let values = this.state.overrides || [];
			const newVal = Object.assign({}, val, {options: path});
			const index = values.findIndex(x => objectCompare(path, x.options));
			if (~index)
				values[index] = newVal;
			else
				values.push(newVal);
			this.props.onOverrideChange(values);
		};
	}
	
	render() {
		const {value, attributes, lookup, images, configurations, onCreateOption, onCreateAttribute, addImage, removeImage, overrides} = this.props;
		
		return (
			<ConfigProvider value={{
				lookup, images, options: value.options, onChange: this.onConfigChange,
				onParentChange: this.onConfigParentChange, addImage, removeImage
			}}>
				<div className="configBuilder">
					<DropDown name="attributes" options={mapObjectName(attributes)} value={value.attributes}
					          onChange={this.onAttributeChange} multiple onCreate={onCreateAttribute}/>
					<div className="configOptions">
						{value.attributes.map(x =>
							<DropDown
								multiple key={x}
								options={attributes[x] ? mapObjectName(attributes[x].options) : {}}
								onChange={val => this.onOptionsChange(x, val)}
								onCreate={val => onCreateOption(x, val)}
								value={value.options[x] || []}/>
						)}
					</div>
					<div className="configurations">
						<ConfigNest attributes={value.attributes} configurations={configurations}
						            overrides={overrides}/>
					</div>
				</div>
			</ConfigProvider>
		);
	}
}

const ConfigNest = ({attributes = [], path = {}, configurations = [], overrides = [], override}) => {
	if (attributes.length < 1) return null;
	let newAttributes = [...attributes];
	const attribute = newAttributes.pop();
	return (
		<ConfigConsumer key={attribute}>
			{({options, lookup: {attributes}, onParentChange}) => {
				const newOverride = override || overrides.filter(x => objectCompare(x.options, {
					...path,
					[attribute]: 0
				}))[0] || undefined;
				return (
					<div className="configNest">
						<div className="nestHeader">
							<h3>{attributes[attribute]}</h3>
							<ConfigPath path={path}/>
						</div>
						<ConfigForm values={newOverride}
						            onChange={val => onParentChange({...path, [attribute]: 0}, val)}
						            override={override}/>
						{(options[attribute] || []).map(x => {
							const newPath = {...path, [attribute]: x};
							const newConfigs = configurations.filter(y => y.options[attribute] === x);
							const newOverrides = overrides.filter(y => y.options[attribute] === x);
							
							if (newAttributes.length < 1) {
								return <ConfigElement key={x} path={newPath} configurations={newConfigs}
								                      override={newOverride}/>
							} else {
								return <ConfigNest key={x + "_nest"} configurations={newConfigs} override={newOverride}
								                   attributes={newAttributes} overrides={newOverrides} path={newPath}/>
							}
						})}
					</div>
				)
			}}
		</ConfigConsumer>
	)
};

const ConfigElement = ({path, configurations = [], override}) => (
	<ConfigConsumer>
		{({onChange}) => (
			<div className="configElement">
				<ConfigPath path={path}/>
				<ConfigForm values={configurations.filter(x => x.options.length === path.length)[0]}
				            onChange={val => onChange(path, val)} override={override}/>
			</div>
		)}
	</ConfigConsumer>
);

const ConfigForm = ({values = {}, onChange, override = {}}) => (
	<ConfigConsumer>
		{({images, addImage, removeImage}) => (
			<ValidateForm className="configForm" values={objectMerge(values, override)} onChange={onChange}>
				<ImageSelect name="imageId" images={images} locked={override.imageId}/>
				<FormInput name="price" type="number" locked={override.price}/>
				<FormInput name="qty" type="number" locked={override.qty}/>
			</ValidateForm>
		)}
	</ConfigConsumer>
);

const ConfigPath = ({path}) => (
	<ConfigConsumer>
		{({lookup: {options, attributes}}) => (
			<div className="configPath">
				{mapObjectToArray(path, (x, i) => <span key={i}>{attributes[i]}: {options[x]}</span>)}
			</div>
		)}
	</ConfigConsumer>
);
//</editor-fold>

//<editor-fold desc="Product Overview">
class ProductOverviewRender extends React.Component {
	
	state = {
		products: [],
		vendors: [],
		order: "id",
		orderAsc: true,
		page: 0,
		loading: false
	};
	
	componentWillMount() {
		const savedData = localStorage.getItem("productAdminFilter");
		if (savedData)
			this.setState(JSON.parse(savedData));
		else
			this.props.awaitVendors(data => this.setState({vendors: mapObjectToArray(data, x => x.id)}));
		
		this.loadProducts();
		
	}
	
	componentWillUnmount() {
		localStorage.setItem("productAdminFilter", JSON.stringify(this.state));
	}
	
	timeout = null;
	search = "";
	
	onSearch(val) {
		this.search = val;
		this.setState({page: 0});
		this.loadProducts();
	}
	
	changeVendors(val) {
		this.setState({vendors: val, page: 0});
		this.loadProducts();
	}
	
	loadProducts() {
		clearTimeout(this.timeout);
		this.timeout = setTimeout(() => {
			this.setState({loading: true});
			this.props.apiCall("GET", "admin/products", products => this.setState({products, loading: false}), {
				search: this.search,
				simple: true,
				limit: 20,
				limitOffset: this.state.page * 20,
				orderBy: this.state.order,
				orderAsc: this.state.orderAsc,
				vendors: this.state.vendors,
				all: true
			})
		}, 1000);
	}
	
	tableChange(data) {
		this.setState(data);
		this.loadProducts();
	}
	
	columns = {
		id: {
			name: "ID",
			sortable: true
		},
		thumbnail: {
			name: "Image",
			render: val => <Image src={getImage(val)}/>
		},
		name: {
			name: "Name",
			sortable: true
		},
		price: {
			name: "Price",
			sortable: true,
			render: val => formatPrice(val)
		},
		vendor: {
			name: "Vendor",
			sortable: true,
			render: val => val ? this.props.vendors[val].name : "N/A"
		},
		productType: {
			name: "Type",
			sortable: true,
			render: val => val ? this.props.productTypes[val] : "N/A"
		},
		isRentable: {
			name: "Rentable",
			render: val => val ? "Yes" : "No"
		},
		disabled: {
			name: "Status",
			sortable: true,
			render: val => !val ? "Enabled" : "Disabled"
		}
	};
	
	render() {
		const {productTypes, vendors, history} = this.props;
		return (
			<div className="wrapper">
				<div className="header">
					<SearchField onSubmit={val => this.onSearch(val)}/>
					<Button to="/products/new">New Product</Button>
					<DropDown options={mapObjectName(vendors)} multiple value={this.state.vendors} onChange={val => this.changeVendors(val)} title="Vendors"/>
				</div>
				<SortedTable
					columns={this.columns}
					onChange={val => this.tableChange(val)}
					loading={isEmpty(vendors) || this.state.loading || isEmpty(productTypes)}
					redirect="/products/"
					redirectProp="id"
					history={history}
					values={this.state}
					rows={this.state.products}/>
			</div>
		);
	}
}

const ProductOverview = reduxWrapper("getApiCall", "loadProductTypes", "loadVendors")(ProductOverviewRender);
//</editor-fold>


// WEBPACK FOOTER //
// ./src/admin/productTool.js